import { createAction } from '@reduxjs/toolkit';

export const CONTACTS_SORTED_DIRECTION_ACTION_TYPE = 'saga/contactsSortedDirection';
export const contactsSortedDirectionAction = createAction(CONTACTS_SORTED_DIRECTION_ACTION_TYPE);
